import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from './paymentForm.module.css';

const mapStateToProps = ({
  language,
  payments: { formattedAmountDue = '', paymentApiKey = '' } = {},
}) => ({
  providerKey: paymentApiKey,
  formTitle: language['returns.step_3.payment_form.title'],
  formDescription: (language['returns.step_3.payment_form.text'] || '').replace(
    '$payment_amount',
    formattedAmountDue,
  ),
  cardNumberLabel: language['returns.step_3.payment_form.card_number.label'],
  expiryLabel: language['returns.step_3.payment_form.expiry.label'],
  cvcLabel: language['returns.step_3.payment_form.cvc.label'],
});

const style = {
  base: {
    color: '#32325d',
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: 'transparent',
    },
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a',
  },
};

/* eslint-disable jsx-a11y/label-has-for */
export const PaymentFormComponent = ({
  providerKey,
  stripeOptions,
  elementsOptions,
  onInit,
  formTitle,
  formDescription,
  cardNumberLabel,
  expiryLabel,
  cvcLabel,
}) => {
  useEffect(() => {
    const stripe = window.Stripe(providerKey, stripeOptions);
    const elements = stripe.elements(elementsOptions);
    const cardNumber = elements.create('cardNumber', { style });
    const cardExpiry = elements.create('cardExpiry', { style });
    const cardCvc = elements.create('cardCvc', { style });
    cardNumber.mount('#card-number');
    cardExpiry.mount('#card-expiry');
    cardCvc.mount('#card-cvc');
    onInit(stripe, cardNumber);
  }, []);

  return (
    <div className={s.payment_form} data-test="payment-form">
      {formTitle && (
        <h2 className={s.payment_form__title} data-test="payment-form-title">
          {formTitle}
        </h2>
      )}
      {formDescription && (
        <div className={s.payment_form__details} data-test="payment-form-description">
          {formDescription}
        </div>
      )}

      <div className={s.stripe_form}>
        <div className={s.payment_element__card}>
          <label htmlFor="card-number" className={s.payment_element__label}>
            {cardNumberLabel}
          </label>
          <div id="card-number" className={s.payment_element__input} />
        </div>

        <div className={s.payment_element__expiry}>
          <label htmlFor="card-expiry" className={s.payment_element__label}>
            {expiryLabel}
          </label>
          <div id="card-expiry" className={s.payment_element__input} />
        </div>

        <div className={s.payment_element__cvc}>
          <label htmlFor="card-cvc" className={s.payment_element__label}>
            {cvcLabel}
          </label>
          <div id="card-cvc" className={s.payment_element__input} />
        </div>
      </div>
    </div>
  );
};

PaymentFormComponent.defaultProps = {
  stripeOptions: undefined,
  formTitle: undefined,
  formDescription: undefined,
  elementsOptions: undefined,
};

PaymentFormComponent.propTypes = {
  providerKey: PropTypes.string.isRequired,
  stripeOptions: PropTypes.shape({
    stripeAccount: PropTypes.string,
  }),
  elementsOptions: PropTypes.shape({
    clientSecret: PropTypes.string.isRequired,
  }),
  onInit: PropTypes.func.isRequired,
  formTitle: PropTypes.string,
  formDescription: PropTypes.string,
  cardNumberLabel: PropTypes.string.isRequired,
  expiryLabel: PropTypes.string.isRequired,
  cvcLabel: PropTypes.string.isRequired,
};

export const PaymentForm = connect(mapStateToProps)(PaymentFormComponent);
